import React, { Component } from 'react';

export default class AdminHome extends Component {

    componentDidMount() {
        document.title = "Administrative Panel";

        fetch('api/userrole', {
            method: 'GET'
        })
        .then(response => {
            if(response.redirected){
                window.location.href = response.url;
            }
        })
        .catch(e => {
            window.location.href = "/adminauth";
        })
    }

    render() {
        return(
            <div>
                <p className='lead'>Welcome to the administrative portal for the St. Louis County Boards and Commissions Application.</p>
                <p>From these pages you will be able to:</p>
                <ul>
                    <li>Manage board information</li>
                    <li>Manage board members</li>
                    <li>View and manage board member applications</li>
                    <li>Run and view reports</li>
                </ul>
                <p>If you encounter any issues or errors in the application, please notify the St. Louis County Helpdesk.</p>
                <p>To add a new administrator to the application, open a help desk ticket.  The new administrator will need to be added to the AD group SS_Boards_Comm.</p>
            </div>
        )
    }
}